import { apiRequest } from "./queryClient";

export interface ClientErrorLog {
  errorCode: string;
  domain: string;
  severity: "debug" | "info" | "warning" | "error" | "critical";
  message: string;
  stack?: string;
  clientUrl?: string;
  clientBrowser?: string;
  metadata?: string;
  reference?: string;
  referenceType?: string;
  referenceId?: string;
}

function detectBrowser(): string {
  const ua = navigator.userAgent;
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Edge")) return "Edge";
  if (ua.includes("Opera") || ua.includes("OPR")) return "Opera";
  return "Other";
}

export async function logClientError(options: Partial<ClientErrorLog> & { message: string }): Promise<void> {
  try {
    const logData: ClientErrorLog = {
      errorCode: options.errorCode || "UI-0001",
      domain: options.domain || "UI",
      severity: options.severity || "error",
      message: options.message,
      stack: options.stack,
      clientUrl: window.location.href,
      clientBrowser: detectBrowser(),
      metadata: options.metadata,
      reference: options.reference,
      referenceType: options.referenceType,
      referenceId: options.referenceId,
    };
    
    await apiRequest("POST", "/api/error-logs", logData);
  } catch (err) {
    console.error("[error-logger] Failed to send error to server:", err);
  }
}

export function initGlobalErrorHandlers(): void {
  window.onerror = (message, source, lineno, colno, error) => {
    logClientError({
      errorCode: "UI-0001",
      message: typeof message === "string" ? message : "Unknown error",
      stack: error?.stack,
      severity: "error",
      metadata: JSON.stringify({
        source,
        lineno,
        colno,
      }),
    });
    return false;
  };
  
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message = reason?.message || "Unhandled promise rejection";
    
    // Don't log 401 errors as they are normal session expiration behavior
    // The session modal will handle these gracefully
    if (message.includes("401") || message.includes("Innlogging kreves")) {
      console.log("[error-logger] Skipping 401 session error logging - handled by session modal");
      return;
    }
    
    logClientError({
      errorCode: "UI-0002",
      message,
      stack: reason?.stack,
      severity: "error",
      metadata: JSON.stringify({
        type: "unhandledrejection",
      }),
    });
  });
  
  console.log("[error-logger] Global error handlers initialized");
}
